<template>
  <div class="social-media-links">
    <ul class="social-media-items-list">
      <li class="linked-item">
        <a href="https://www.linkedin.com/in/mahmoud-salameh/" target="_blank">
          <i class="fab fa-linkedin-in"></i>
        </a>
      </li>
      <li class="twitter-item">
        <a href="https://twitter.com/MohammNezar" target="_blank">
          <i class="fab fa-twitter"></i>
        </a>
      </li>
      <li class="whatsapp-item">
        <a href="https://wa.me/962770675590?text=Hello Mahmoud,Can%20We%20Talk" target="_blank">
          <i class="fab fa-whatsapp"></i>
        </a>
      </li>
      <li class="facbook-item">
        <a href="https://www.facebook.com/mahmood.sarhan.33" target="_blank">
          <i class="fab fa-facebook-f"></i>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
.social-media-links {
  position: fixed;
  bottom: 1px;
  z-index: 200000;
  right: 8px;
  height: 40px;
}

.social-media-links.movedUp {
  bottom: 35px;
  height: 30px;
}

.social-media-items-list {
  text-decoration: none;
  list-style-type: none;
  margin-bottom: 0px !important;
  float: right;
  margin-left: 0px;
  padding-left: 0px;
}

.social-media-items-list li {
  display: inline;
  margin: 2px;
}

.social-media-items-list li a i {
  display: inline-block;
  height: 18px;
  font-size: 17px;
  color: #adc9ce;
  margin: 7px;
  -webkit-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
}

.social-media-items-list li a i:hover {
  color: rgb(196, 166, 166);
}

@media (min-width: 481px) and (max-width: 767px),
  (min-width: 320px) and (max-width: 480px),
  (min-width: 768px) and (max-width: 1024px) {
  .social-media-items-list li a i:hover {
    color: #adc9ce;
  }
  .social-media-links {
    height: 30px;
  }

  .social-media-links.movedUp {
    display: none;
  }
}

@media only screen and (max-width: 400px) {
  .social-media-items-list li a i {
    margin: 7px;
    margin-left: 4px;
    margin-right: 4px;
    -webkit-transition: 0.3s;
    -o-transition: 0.3s;
    transition: 0.3s;
  }
}
</style>